import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { resendVerificationEmail, signOut } from '../../adapters/authentication';
import SuccessStatus, { ErrorStatus } from '../../components/FormStatus';
import AuthLayout from '../../layouts/AuthLayout';
import useAuthStore from  '../../store/auth';
import Cookies from 'js-cookie';

export default function EmailVerification({ match }) {

  const [ showStatus , setShowStatus ] = useState(false);
  const [ errors, setErrors ] = useState([]);

  const navigate = useNavigate();
  const token = useAuthStore((state) => state.token);
  const clearAuth = useAuthStore((state) => state.clearAuth);


  useEffect(() => {
    setTimeout(() => {
        setShowStatus(false);
    }, 5000)
  }, [showStatus])


  const resendLink = async () => {
    await resendVerificationEmail(token).then((res) => {
      if(res.status === 200) {
        setShowStatus(true);
      }else{
        setErrors(['Failed to send Verification link'])
      }
    }).catch((err) => {
      setErrors(['Failed to send Verification link'])
    })
  }

  const logout = () => {
    clearAuth();
    signOut();
    Cookies.remove('auth:token')
    navigate("/auth/sign-in", { replace: true });
  }


  return (
    <AuthLayout title="Email Verification">
      <p className="mb-6 text-sm text-center ">
        Your account was created successfully please check your email for verification instructions.
      </p>
      <ErrorStatus errors={errors} />
      <SuccessStatus showStatus={showStatus} message="Verification code was sent successfully" />

      <form onSubmit={(e) => {
        e.preventDefault();
        resendLink();
      }}>
        <button className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg " type="submit">
          Resend Email Verification Code
        </button>
        <div className="mt-4 flex items-center justify-center w-full relative">
          <span className="absolute px-1 py-0 text-center mx-auto text-xs font-semibold"> Or </span>
        </div>
        <button onClick={logout} className="py-3 font-fira gap-2 mt-1 hover:text-red-900  text-sm font-semibold w-full text-center flex justify-center items-center text-blue-800 rounded-lg ">
          <span>
            Sign Out
          </span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
              <path fillRule="evenodd" d="M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z" clipRule="evenodd" />
              <path fillRule="evenodd" d="M19 10a.75.75 0 00-.75-.75H8.704l1.048-.943a.75.75 0 10-1.004-1.114l-2.5 2.25a.75.75 0 000 1.114l2.5 2.25a.75.75 0 101.004-1.114l-1.048-.943h9.546A.75.75 0 0019 10z" clipRule="evenodd" />
            </svg>
          </span>
        </button>
      </form>
    </AuthLayout>
  )
}
